import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import { MRQDetailsGrid } from "../utils";
import LabelledBox from "../../../../../../../../components/widgets/LabelledBox";
import CopyUrlButton from "../../../../../../../../components/btns/CopyLinkBtn";
import { useMcsContext } from "../../../MCS.context";

const MrqDetails = ({ mrq: mrqData, addCopyBtn = true, focusOnRev }) => {
  const { plant } = useMcsContext();

  const link =
    `/plant/${plant.id}/mcs#mcs-tab=Drawing+BOM&bom-tab=MRQ&mrq-id=` +
    mrqData?.id;

  return (
    <LabelledBox label="MRQ Details" sx={{ position: "relative" }}>
      {mrqData?.id && addCopyBtn && (
        <CopyUrlButton
          label="Copy MRQ Link"
          sx={{ position: "absolute", top: -40, right: 5 }}
          subLink={link}
        />
      )}
      {mrqData?.id && addCopyBtn && (
        <Typography
          sx={{ position: "absolute", top: 5, right: 10, color: "#888" }}
        >
          ID: {mrqData?.id}
        </Typography>
      )}
      <Grid container spacing={2} columns={{ xs: 6.8 }} sx={{ width: "900px" }}>
        {MRQDetailsGrid.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <Grid item xs={item.grid}>
                <Typography
                  sx={{
                    backgroundColor:
                      focusOnRev && item.field === "rev" && "yellow",
                  }}
                >
                  {focusOnRev && item.field === "rev" ? "New Rev" : item.label}
                </Typography>
                {/* <Box sx={{ backgroundColor: "red" }}>{item.label}</Box> */}
              </Grid>
              {/* <Grid item xs={item.label === "From" || item.label === "Title" ? 2.6 : 1} > */}
              <Grid
                item
                xs={["Title", "Document #"].includes(item.label) ? 2.6 : 1}
              >
                {/* <Typography color={"GrayText"}>Values</Typography> */}
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  hiddenLabel
                  size="small"
                  disabled
                  fullWidth
                  value={
                    item.field === "plant"
                      ? plant.name
                      : item.field === "documentTitle"
                        ? mrqData?.document?.title
                        : mrqData?.[item.field]
                  }
                  inputProps={{ sx: { padding: "2px", pl: "5px" } }}
                  sx={{
                    border: focusOnRev && item.field === "rev" && "1px solid",
                    borderColor:
                      focusOnRev && item.field === "rev" && "primary.main",
                    borderRadius: focusOnRev && item.field === "rev" && 1,
                  }}
                />
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
    </LabelledBox>
  );
};

export default MrqDetails;
